// Conversion tracking: Google Analytics 4 (+ Meta Pixel if it is ever added to index.html)

const ga = (...args) => {
  if (typeof window.gtag === 'function') window.gtag(...args);
};

export const trackLeadConversion = (data = {}) => {
  if (typeof window.fbq === 'function') {
    window.fbq('track', 'Lead', { content_name: data.source || 'Wedding Inquiry', currency: 'INR' });
  }
  ga('event', 'generate_lead', {
    event_category: 'Lead',
    event_label: data.source || 'Wedding Inquiry',
    lead_source: data.source || 'website',
  });
};

export const trackFormView = (formName) => {
  if (typeof window.fbq === 'function') window.fbq('track', 'ViewContent', { content_name: formName });
};

export const trackPhoneClick = () => {
  if (typeof window.fbq === 'function') window.fbq('track', 'Contact');
  ga('event', 'phone_click', { event_category: 'Lead' });
};

export const trackWhatsAppClick = () => {
  if (typeof window.fbq === 'function') window.fbq('trackCustom', 'WhatsAppClick');
  ga('event', 'whatsapp_click', { event_category: 'Lead' });
};
